import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ToggleButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.subtle};
  text-decoration: underline;
  margin-top: 16px;
`;

const BackupCodeToggle = ({ useBackupCode, onToggle, 'data-cy': dataCy }) => (
  <ToggleButton type="button" onClick={onToggle} data-cy={dataCy}>
    {useBackupCode ? 'Use authenticator app' : 'Use backup code'}
  </ToggleButton>
);

BackupCodeToggle.propTypes = {
  useBackupCode: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  'data-cy': PropTypes.string,
};

BackupCodeToggle.defaultProps = {
  useBackupCode: false,
  'data-cy': undefined,
};

export default BackupCodeToggle;
